const initialiseBathwiseSwatches=()=>{
  document.querySelectorAll('[data-bw-product-card]').forEach(card=>{
    if(card.dataset.bwSwatchesReady==='true') return;
    card.dataset.bwSwatchesReady='true';
    const image=card.querySelector('.bw-product__card-image');
    const links=[...card.querySelectorAll('[data-bw-card-link]')];
    const price=card.querySelector('[data-bw-card-price]');
    const sku=card.querySelector('[data-bw-card-sku]');
    const skuValue=card.querySelector('[data-bw-card-sku-value]');
    const compare=card.querySelector('[data-bw-card-compare]');
    const swatches=[...card.querySelectorAll('[data-bw-finish-swatch]')];
    if(!swatches.length) return;

    swatches.forEach(swatch=>{
      swatch.addEventListener('click',()=>{
        swatches.forEach(item=>{
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed','false');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed','true');

        if(swatch.dataset.url) links.forEach(link=>link.href=swatch.dataset.url);
        if(price&&swatch.dataset.price) price.textContent=swatch.dataset.price;
        if(sku&&skuValue){
          skuValue.textContent=swatch.dataset.sku||'';
          sku.hidden=!swatch.dataset.sku;
        }
        if(compare){
          if(swatch.dataset.compare){compare.textContent=swatch.dataset.compare;compare.hidden=false;}
          else{compare.textContent='';compare.hidden=true;}
        }
        if(image&&swatch.dataset.image){
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src=swatch.dataset.image;
          if(swatch.dataset.alt) image.alt=swatch.dataset.alt;
        }
      });
    });
  });
};
document.addEventListener('DOMContentLoaded',initialiseBathwiseSwatches);
document.addEventListener('bw:product-cards-loaded',initialiseBathwiseSwatches);
